import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";


// TODO @branch @Darius these objects should better mirror what the backend models do, inheriting a base model
export class MerchantPG extends StoreObject {
    @field("Merchant") merchant;

    @field("MerchantSDKSettings") settingsVersion;
    @field("MerchantPG") versionParent;

    @field(String) name;
    @field(Object) options;
    @field(Object) dashboardOptions;

    toString() {
        return this.name;
    }

    // TODO: Maybe have panelType as a DB field?
    getPrimaryPanelType() {
        return this.panelType ?? Object.keys(this.options ?? {})[0] ?? null;
    }

    isMocked() {
        return this.getStore() == null;
    }
}

export async function apiCreateMerchantPG(data) {
    const response = await apiClient.post("merchant/create_pg/", data);
    return loadVersionedObjectFromResponse(MerchantPGStore, response, null);
}

export async function apiUpdateMerchantPG(data) {
    const response = await apiClient.post("merchant/update_pg/", data);
    return loadVersionedObjectFromResponse(MerchantPGStore, response, data.merchantPgId);
}

export async function apiDeleteMerchantPG(data) {
    return apiClient.post("merchant/delete_pg/", data);
}

export const MerchantPGStore = MakeStore("MerchantPG", MerchantPG, {
    dependencies: ["Merchant", "MerchantSDKSettings"],
});
